
    import Vue from 'vue';
    import saveEmissionService from '../../../shared/services/saveEmission-service';
    import getSelectedProducerService from '../../../shared/services/selectedProducer-service';
    export default Vue.extend({
        el: '#step2',
        name: 'TabTwo',
        data() {
            return {
                modeloDispositivo: null,
                marcaDispositivo: null,
                goodSelected: null,
                stepOneData: null,
                DataGood: null,
                goodId: null,
                marcaDispositivoInvalid: false,
                clientCode: "0",
                originId: 4,
                producerDataLoaded: false,
                referente: null,
            }
        },
        methods: {
            validate: function (config, direction) {
                var timeStart = new Date();
                sessionStorage.setItem("TimeStart", JSON.stringify(timeStart));
                var formIsValid = NF.Validation.Form.validate('#form2Client');
                if (!formIsValid) {
                    return formIsValid;
                }
                if (direction != "backward" && this.marcaDispositivo != null) {
                    this.SaveEmission();
                }
                else {
                    if (this.marcaDispositivo == null) {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': this.stepOneData.email,
                            'product': 'tecnologia',
                            'event': 'errorUsuario',
                            'paso': 'cotizador-tecnologia-datos-equipo',
                            'referente': this.referente
                        });
                        this.marcaDispositivoInvalid = true;
                        return false;
                    }
                    return formIsValid;
                }
            },

            validMarca: function () {
                this.marcaDispositivo != null ? this.marcaDispositivoInvalid = false : true;
            },

            showRuletaErrorModal(show) {
                if (show) {
                    this.$refs.modalErrorRuleta.open();
                }
                else {
                    this.$refs.modalErrorRuleta.close();
                }
            },

            retryEmission() {
                sessionStorage.removeItem("producerData");
                this.producerDataLoaded = false;
                this.showRuletaErrorModal(false);
                this.startProducerDataTask()
                this.SaveEmission();

            },

            startProducerDataTask() {
                return new Promise((resolve, reject) => {
                    this.stepOneData = JSON.parse(sessionStorage.getItem("stepOneData"));
                    if (this.stepOneData != null) {
                        getSelectedProducerService.GetSelectedProducer(
                            this.clientCode,
                            this.stepOneData.localityId,
                            0,
                            this.originId,
                            this.stepOneData.zipCode
                        ).then(producerData => {
                            sessionStorage.setItem("producerData", JSON.stringify(producerData));
                            this.producerDataLoaded = true;
                            resolve(true);
                        }).catch(error => {
                            this.showRuletaErrorModal(true);
                            reject(error);
                        });
                    }
                });
            },

            waitForProducerData() {
                return new Promise((resolve, reject) => {
                    const timeout = setTimeout(() => {
                        this.showRuletaErrorModal(true);
                        reject(new Error("Timeout: Ruleta respondio en mas de 1 minuto"));
                    }, 60000); // espera 1 minuto y tira timeout de ruleta

                    const checkProducerDataLoaded = () => {
                        if (this.producerDataLoaded) {
                            clearTimeout(timeout); // Limpia el timeout si los datos se cargan a tiempo
                            resolve(true);
                        } else {
                            setTimeout(checkProducerDataLoaded, 200); // Vuelve a verificar después de 200ms
                        }
                    };
                    checkProducerDataLoaded();
                });
            },

            async SaveEmission() {
                try {
                    await this.waitForProducerData();
                    var DataGood = JSON.parse(sessionStorage.getItem("DataGood"));
                    DataGood = { ...DataGood, goodBrand: this.marcaDispositivo, goodModel: this.modeloDispositivo }
                    sessionStorage.setItem("DataGood", JSON.stringify(DataGood));
                    const producerData = JSON.parse(sessionStorage.getItem("producerData"));
                    if (!producerData) {
                        NF.UI.Page.unblock();
                        this.showRuletaErrorModal(true);
                        return;
                    }
                    const birthDay = this.stepOneData.birthDay || "01/01/1900";
                    const dateFormat = new Date(birthDay);
                    const JsonEmissionData = JSON.stringify({
                        birthday: dateFormat,
                        cityCode: parseInt(this.stepOneData.localityId),
                        clientAddress: {
                            department: this.stepOneData.numDept == null ? "" : this.stepOneData.numDept.toString(),
                            floor: parseInt(this.stepOneData.piso == null ? 0 : this.stepOneData.piso),
                            streetName: this.stepOneData.streetName == null ? "" : this.stepOneData.streetName.toString(),
                            streetNumber: this.stepOneData.numDom == null ? "" : this.stepOneData.numDom.toString(),
                        },
                        clientFirstName: this.stepOneData.firstName ? this.stepOneData.firstName.toString() : "",
                        clientLastName: this.stepOneData.lastName ? this.stepOneData.lastName.toString() : " ",
                        documentNumber: parseInt(this.stepOneData.documentNumber),
                        documentType: this.stepOneData.documentType.id.trim(),
                        email: this.stepOneData.email ? this.stepOneData.email.toString() : null,
                        phones: [{
                            areaCode: this.stepOneData.telephone ? parseInt(this.stepOneData.areaCode) : null,
                            countryCode: this.stepOneData.telephone ? parseInt(this.stepOneData.telephone[0].countryCode) : null,
                            order: this.stepOneData.telephone ? parseInt(this.stepOneData.telephone[0].order) : null,
                            phoneNumber: this.stepOneData.telephone ? this.stepOneData.telephone.toString() : "",
                            phoneType: this.stepOneData.telephone ? parseInt(this.stepOneData.telephone[0].phoneType) : null
                        }],
                        zipCode: this.stepOneData.zipCode,
                        insuredGoodDetail: {
                            BrandDescription: this.marcaDispositivo,
                            InsuredGoodDescription: this.goodSelected,
                            InsuredGoodId: this.goodId,
                            ModelDescription: this.modeloDispositivo,
                        },
                    });

                    const response = await saveEmissionService.TheftElectronicDeviceSaveEmission(JsonEmissionData);
                    if (response.validationResult.errorMessage === "Los datos para la emisión se guardaron correctamente") {
                        NF.UI.Page.block();
                        this.Bus.$emit('redirectSummary');
                    } else {
                        this.showRuletaErrorModal(true);
                    }

                }
                catch (error) {
                    NF.UI.Page.unblock();
                    this.showRuletaErrorModal(true);
                }
            },
            getInitData() {
                var ProductData = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                if (ProductData != null) {
                    this.goodSelected = ProductData.productDescription;
                    this.goodId = ProductData.code;
                };
                this.startProducerDataTask();
                NF.UI.Page.block();
                setTimeout(() => {
                    NF.UI.Page.unblock();
                }, 2000);
            }
        },
        watch: {
            //!!newVal convierte newVal en un valor booleano,
            //de manera que this.validCelular recibirá true si newVal es un valor "verdadero" y false si es "falso".
            SelectedNotebook(newVal) {
                return this.validNotebook = !!newVal;
            },
            SelectedAuricular(newVal) {
                return this.validAuricular = !!newVal;
            },
            SelectedCelular(newVal) {
                return this.validCelular = !!newVal;
            },
            SelectedTablet(newVal) {
                return this.validTablet = !!newVal;
            }
        },
        mounted() {
            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

            this.getInitData();
        },
    });
